import { TopolSpacerBlock } from "@/schemas/template/blocks/spacerBlockSchema";
import calcWidth from "./helpers";
import { v4 as uuidv4 } from "uuid";
import { useMjmlStore } from "@/stores/mjmlStore";

export default {
  getData(
    state: any,
    props: { sectionIndex: number; columnIndex: number }
  ): TopolSpacerBlock {
    const mjmlStore = useMjmlStore();
    const attributes: TopolSpacerBlock["attributes"] = {
      height: mjmlStore.getBaseAttrString("mj-spacer", "height") || "50px",
      containerWidth: calcWidth(
        state.mjml.children[0].attributes["containerWidth"],
        state.mjml.children[0].children[props.sectionIndex].children[
          props.columnIndex
        ].attributes["width"]
      ),
    };

    const bgColor = mjmlStore.getBaseAttrString(
      "mj-spacer",
      "container-background-color"
    );
    if (bgColor) {
      attributes["container-background-color"] = bgColor;
    }

    const gradient = mjmlStore.getBaseAttrString(
      "mj-spacer",
      "container-gradient"
    );
    if (gradient) {
      attributes["container-gradient"] = gradient as string;
    }

    return {
      uid: uuidv4(),
      tagName: "mj-spacer",
      attributes,
    };
  },
};
